import { render, staticRenderFns } from "./FilterSave.vue?vue&type=template&id=66fae7e6"
import script from "./FilterSave.vue?vue&type=script&lang=js"
export * from "./FilterSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports